import { rem } from 'polished'
import styled, { css } from 'styled-components'
import { margin, maxWidth, minWidth, width } from 'styled-system'
import { Props } from '.'
import { Span } from '../Typography'
import { regular } from '../Typography/Text'

type StyledButtonProps = Props & {}

const variants = {
  primary: css<StyledButtonProps>`
    box-sizing: border-box;
    background: ${(p) => p.theme.rolex.colors.primary};
    color: white;
    border: 1px solid ${(p) => p.theme.rolex.colors.primary};
    &:hover {
      background: ${(p) => !p.isLoading && `transparent`};
      color: ${(p) => !p.isLoading && p.theme.rolex.colors.primary};
    }
  `,
  secondary: css<StyledButtonProps>`
    color: ${(p) => p.theme.rolex.colors.primary};
    background: white;
    border: 1px solid ${(p) => p.theme.rolex.colors.primary};
    &:hover {
      background: ${(p) => !p.isLoading && p.theme.rolex.colors.primary};
      color: ${(p) => !p.isLoading && 'white'};
    }
  `,
  tertiary: css<StyledButtonProps>`
    background: transparent;
    border: 1px solid white;
    color: white;
    &:hover {
      background: white;
      color: ${(p) => p.theme.rolex.colors.primary};
    }
  `,
}

export const Button = styled.button<StyledButtonProps>`
  ${margin};
  ${width};
  ${minWidth};
  ${maxWidth};
  ${width};
  ${regular};
  ${(p) => variants[p.variant]};
  padding: ${rem(11)} 2rem;
  align-items: center;
  transition: all 0.2s ease-in-out;
  border-radius: 1.875rem;
  position: relative;
  font-weight: 400;
  outline: 0;
  display: inline-flex;
  ${(p) =>
    p.isLoading
      ? css`
          cursor: wait;
        `
      : css`
          &:disabled {
            background: ${(p) => p.theme.colors.shades[200]};
            border-color: transparent;
            color: ${(p) => p.theme.colors.shades[700]};
            cursor: not-allowed;
          }
        `}

  svg {
    margin-left: ${(p) => !p.isLoading && p.iconPosition === 'right' && '1.5rem'};
    margin-right: ${(p) => !p.isLoading && p.iconPosition === 'left' && '1.5rem'};
    width: 0.75rem;
    height: 0.75rem;
  }
`
export const Link = styled(Button).attrs({ as: 'a' })``

export const Content = styled(Span)`
  align-items: center;
  justify-content: center;
`
